import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, autofill, reduxForm } from "redux-form";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import Util from "../../../Common/util";
import API from "../../../Common/api";

import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import { PostAddTwoTone } from "@material-ui/icons";

import { useMemo, useState } from 'react'
import { useTable, usePagination ,useGlobalFilter} from 'react-table'
import { useAsyncDebounce } from 'react-table'
// import 'bootstrap/dist/css/bootstrap.min.css';
import { Hidden } from "@material-ui/core";

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var today_date;
var tomm_date;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = (csvData,GROUPED_COLUMNS, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [
    ["","","","","","ERP","ERP","ERP","ERP","JARVIS","JARVIS","JARVIS","JARVIS","JARVIS","JARVIS","JARVIS","JARVIS"],
    [
      "City","Warehouse", "Brand",  "Product Code", "Weight Avg Rate",  "Accepted"  ,"Allocated"  ,"Rejected" ,"Total Value","Accepted",  "Allocated",  "Warehouse Damaged",  "Warehouse Expired" ,"Market Damaged" ,"Market Expired",  "Total Rejected", "Total Value"
    ],
  ];
  // const Heading = GROUPED_COLUMNS;
  const ws = XLSX.utils.json_to_sheet(csvData, {
    origin: "A3",
    skipHeader: true,
  });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" });
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };
  

  constructor() {
    super();

    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventory = this.fetchInventory.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      filtered_orderData: [],
      loading_overlay: false,
      showPassword: false,
      pastYearData: [],
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: "masterFile",
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      showYear: false,
      showQtr: false,
      showMonth: false,
      showDaily: false,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      selectedSubGroup: "",
      error_modal : false,
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
    var currentYear = new Date().getFullYear();

// Get the past three years
var pastThreeYears = [];
for (var i = 0; i < 2; i++) {
    pastThreeYears.push(currentYear - i);
    this.setState({
      pastYearData: pastThreeYears
    })
}

console.log("Current Year:", currentYear);
console.log("Past Three Years:", pastThreeYears);
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };
  convertDate1 = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getDate()-1), pad(d.getMonth() + 1), d.getFullYear()].join("-");
  };
  convertDate2 = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("-");
  }
  FromDateChange = (date) => {
    this.setState({
      fromdate: date,
      showFromErr: false,
    });
    if (date) {
      From_Date_val = this.convertDate(date);
      tomm_date = this.convertDate2(date);
      today_date = this.convertDate1(date);
    } else {
      this.setState({
        fromdate: "",
      });
      From_Date_val = "";
    }
  };

  ToDateChange = (date) => {
    this.setState({
      todate: date,
      showToErr: false,
    });
    if (date) {
      to_Date_val = this.convertDate(date);
      tomm_date = this.convertDate2(date);
      today_date = this.convertDate1(date);
    } else {
      this.setState({
        todate: "",
      });
      to_Date_val = "";
    }
  };

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  handleSubGroupChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedSubGroup: value,
    });
  };

  fetchInventory() {
    //alert("gfvhv");
    this.setState({
      loading_overlay: true
    })
    var queryParam;
   

      if(this.state.optionChangeVal == "quarterly"){
        queryParam = this.state.year+"_"+this.state.quarter
      }else if(this.state.optionChangeVal == "monthly"){
        queryParam = this.state.year+"_"+this.state.month
      }else{
        queryParam = to_Date_val
      }

       //alert("gfvhv");

   API.get('/mis/fetchInventoryMovementReport?request_type=0&date='+ queryParam + '&data_type=1')
      .then((response) => response.data)

      .then((data) => {
        // this.setState({ posts: data.data, filtered_orderData: data.data });
        this.setState ({tableRows: this.assemblePosts(data), showFetchBinData: true});
      
        
      })

      .then(async () => {
        this.setState({  isLoading: false });

      });
  }
  errorModaltoggle = () => {
    this.setState({error_modal :false})
  }
  filterData = (evt) => {
  
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      var value = this.state.posts.filter((val) => {
        return Object.keys(val).some((key) => {
          var data = "";
          if (val[key] == null) {
            data = "";
          } else {
            data = val[key];
          }

          return data.toString().toLowerCase().includes(evt.toLowerCase());
        });
      });

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  onOptionChange = (evt)=>{
    var option = evt.target.value;
    this.setState({
      optionChangeVal: evt.target.value
    })

    if(option == "quarterly"){
      this.setState({
        showYear: true,
        showQtr: true,
        showMonth: false,
        showDaily: false
      })
    } else if(option == "monthly"){
      this.setState({
        showYear: true,
        showQtr: false,
        showMonth: true,
        showDaily: false
      })
    }else if(option == "daily"){
      this.setState({
        showYear: false,
        showQtr: false,
        showMonth: false,
        showDaily: true
      })
    }

  }

  assemblePosts = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else {
        status = " Not Active";
      }
      return {
        city: post['City'],
        warehouse : post['WH'],
        brand : post['Brand'],
        item_code : post["Item code"],
        item_desc : post['Item description'],
        mrp : post['MRP'],
        opening_inv_qty : post['Opening Inv Qty'],
        opening_inv_value : post['Opening Inv value'],
        picking_conf: post['Picking Conf'],
        putaway_conf: post['Putaway Conf'],
        intransit_qty : post['Intransit Qty'],
        intransit_value : post['Intransit Value'],
        inbound_qty : post['Inbound Qty'],
        inbound_value : post['Inbound Value'],
        outbound_qty : post['Outbound Qty'],
        outbound_value : post['Outbound Value'],
        return_qty : post['Returns Qty'],
        return_value : post['Returns Value'],
        adjustment_qty : post['Adjustment Qty'],
        adjustment_value : post['Adjustment Value'],
        computed_qty : post['System computed closing Qty'],
        computed_value :  post['System computed closing Value'],
        actual_qty : post['Actual closing Qty'],
        actual_value : post['Actual closing Value'],
        diff_qty : post['Diff Qty'],
        diff_value : post['Diff Value'],
        
        
      };
    });

    this.setState({
      loading_overlay: false,
      filtered_orderData : posts,
      posts              : posts,
    });
    

    return posts;
  };

  handleChange = (evt)=>{

    this.setState({[evt.target.name]: evt.target.value})

  }

  processData() {
    this.setState({
      loading: true,
    });
  }

  downloadError = () => {
    this.setState({loading:true})
    /*const payload = {
      location: this.state.selectedLocation,

      end_date: to_Date_val,
  };*/

    var queryParam;
   

      if(this.state.optionChangeVal == "quarterly"){
        queryParam = this.state.year+"_"+this.state.quarter
      }else if(this.state.optionChangeVal == "monthly"){
        queryParam = this.state.year+"_"+this.state.month
      }else{
        queryParam = to_Date_val
      }

API.get('/mis/fetchInventoryMovementReport?request_type=0&date='+ queryParam + '&data_type=0')
      .then((response) => response.data) 
       .then((data) => {
    
        this.setState({loading:false})
        window.location.href = data.url;
      })
      .catch(function (error) {});
  };
  
    

  render() {
    
    
    const GROUPED_COLUMNS = [
      
      {
        Header: 'City',
        accessor: 'city'
      },
      { Header : 'Opening : previous day / Closing : current day',
      columns : [
      {
        Header: 'WH',
        accessor: 'warehouse'
      },
      
      {
        Header: 'Brand',
        accessor: 'brand'
      },
      {Header : 'Item Code',
       accessor: 'item_code',
      },
      {Header : 'Item Desc',
      accessor : 'item_desc',

      }]
    },
    {
      Header:"Mrp",
      accessor : "mrp"
    },

      {
          Header : "Opening Inv",
          columns : [{
            
              Header: 'Qty',
              accessor: 'opening_inv_qty'
            },
            {
              Header: 'Value',
              accessor: 'opening_inv_value'
            }]
      },

       {
          Header : "Transit Inv",
          columns : [{
            
              Header: 'Picking Conf',
              accessor: 'picking_conf'
            },
            {
              Header: 'Putaway Conf',
              accessor: 'putaway_conf'
            }]
      },


      {
          Header : "In transit",
          columns : [{
            
              Header: 'Qty',
              accessor: 'intransit_qty'
            },
            {
              Header: 'Value',
              accessor: 'intransit_value'
            }]
      },
      
      {
          Header : "Inbound",
          columns : [{
            
              Header: 'Qty',
              accessor: 'inbound_qty'
            },
            {
              Header: 'Value',
              accessor: 'inbound_value'
            }]
      },

      {
          Header : "Outbond",
          columns : [{
            
              Header: 'Qty',
              accessor: 'outbound_qty'
            },
            {
              Header: 'Value',
              accessor: 'outbound_value'
            }]
      },
      {
          Header : "Returns",
          columns : [{
            
              Header: 'Qty',
              accessor: 'return_qty'
            },
            {
              Header: 'Value',
              accessor: 'return_value'
            }]
      },

       {
          Header : "Adjustments",
          columns : [{
            
              Header: 'Qty',
              accessor: 'adjustment_qty'
            },
            {
              Header: 'Value',
              accessor: 'adjustment_value'
            }]
      },

       {
          Header : "System Computed",
          columns : [{
            
              Header: 'Qty',
              accessor: 'computed_qty'
            },
            {
              Header: 'Value',
              accessor: 'computed_value'
            }]
      },

       {
          Header : "Actual Closing",
          columns : [{
            
              Header: 'Qty',
              accessor: 'actual_qty'
            },
            {
              Header: 'Value',
              accessor: 'actual_value'
            }]
      },

       {
          Header : "Diff",
          columns : [{
            
              Header: 'Qty',
              accessor: 'diff_qty'
            },
            {
              Header: 'Value',
              accessor: 'diff_value'
            }]
      },
    ]


  
    const GlobalFilter = ({ filter, setFilter }) => {
      const [value, setValue] = useState(filter)
      const onChange = useAsyncDebounce(value => {
        setFilter(value || undefined)
      }, 1000)
      return (
        <span >
          {' '}
          <input  className="input_border"
            value={value || ''}
            placeholder="Search"
            onChange={e => {
              setValue(e.target.value);
              onChange(e.target.value);
              
              
            }}
          />
        </span>
      )
    }
    const PaginationTable = () => {
      const columns = useMemo(() => GROUPED_COLUMNS, [])
      const data = useMemo(() => this.state.posts, [])
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        state,
        setGlobalFilter,
        gotoPage,
        pageCount,
        setPageSize,
        prepareRow
      } = useTable(
        {
          columns,
          data,
          initialState: { pageIndex: 0 ,pageSize: 15},
        
          
        },
        useGlobalFilter,
        usePagination,
        
      )
    
      const { pageIndex, pageSize,globalFilter } = state
    
      return (
        <>
        <div><p>*Count of Bills Packed between {today_date} 06:00 AM and {tomm_date} 06:00 AM</p></div>
        <div style={{textAlign:"right", paddingBottom:"5px",marginTop:"-10px"}}><GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}/></div>
      <table id ="customers" style ={{width:"100%"}}{...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
        
      </table>
      
      <div className="pagination__style" style={{textAlign:"center",margin : "10px 0px 1px 0px"}}>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          Prev
        </button>{' '}
        <span>
          {/* Page{' '} */}
          <strong>
            {pageIndex + 1} {/*of {pageOptions.length}*/}
          </strong>{' '}
        </span>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
       
        {/* <span>
          | Go to page:{' '}
          <input
            type='number'
            defaultValue={pageIndex + 1}
            onChange={e => {
              const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(pageNumber)
            }}
            style={{ width: '50px' }}
          />
        </span>{' '} */}
        <select
          value={pageSize}
          onChange={e => setPageSize(Number(e.target.value))}>
          {[20, 40, 60, 80].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> 
      </div>
    </>

      )
    }
    return (
      <Col style={{padding: 0}} xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            ></LoadingOverlay>
          </DarkBackground>
        )}
        <Card style={{padding: 0}}>
          <CardBody
            style={{
              paddingTop: 10,
              height: 70,
              paddingBottom: 0,
              marginBottom: "-13px",
              marginTop:"-15px"
            }}
          >
            <form className="form">

            <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onOptionChange}
                  >
                    <option value="">Select any one</option>
                    <option value="quarterly">Quarterly </option>
                    <option value="monthly">Monthly </option>
                    <option value="daily">Daily </option>

                       
                  </select>
                  </div>
                  </div>

                  {this.state.showYear &&

                   <div 
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.handleChange}
                    name="year"
                   
                  >
                    <option value="">Select Year</option>
                   {
                     this.state.pastYearData.map((item) => {
                        return (
                          <option value={item}>{item} </option>
                        );
                      })}
                       
                  </select>
                  </div>
                  </div>
                }


                      {this.state.showQtr &&

                   <div
                style={{ width: '13%',  marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    name= "quarter"
                    onChange={this.handleChange}
                    style={{ fontSize: 13,  width: 190 }}
                    
                  >
                    <option value="">Select Qtr</option>
                    <option value="quarterly1">Qtr1 </option>
                    <option value="quarterly2">Qtr2 </option>
                    <option value="quarterly3">Qtr3 </option>
                    <option value="quarterly4">Qtr4 </option>

                       
                  </select>
                  </div>
                  </div>
                }

                  {this.state.showMonth &&

                    <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    name="month"
                    onChange={this.handleChange}
                   
                  >
                    <option value="">Select month</option>
                    <option value="January">January </option>
                    <option value="February">February </option>
                    <option value="March">March </option>
                    <option value="April">April </option>
                    <option value="May">May </option>

                    <option value="June">June </option>

                    <option value="July">July </option>
                    <option value="August">August </option>
                    <option value="September">September </option>
                    <option value="October">October </option>
                    <option value="November">November </option>
                    <option value="December">December </option>


                       
                  </select>
                  </div>
                  </div>
                }

                {this.state.showDaily &&
             
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="Select Date"
                />
                {this.state.showToErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select Date
                  </span>
                )}
              </div>
            }

                

              <div
                style={{
                  width: "9%",
                  marginBottom: "0px",
                  marginLeft: "60px",
                  float: "left",
                }}
              >
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchInventory()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>
              <div className="download_excel_style" style={{ width: "6%", marginBottom: "0px", float: "left" }}>
                 <button
                  type="button"
                  style={{backgroundColor: '#fff', border: 0}}
                   onClick={this.downloadError}
                >
                <img
                    src={require("../../../../images/download.png")}
                    onClick={this.state.downloadError}
                  /> 
                  {/*<img
                    src={require("../../../../images/download.png")}
                    onClick={(e) =>
                      exportToCSV(
                        this.state.filtered_orderData,GROUPED_COLUMNS,
                        "ERP vs JARVIS Inventory Report"
                      )
                    }
                  />*/}
                  </button>

              </div>
            </form>
          </CardBody>
          {this.state.showFetchBinData && (
            <CardBody style={{ marginTop: 20 ,height:"660px"}}>
             
              
              <PaginationTable/>
              
            </CardBody>
          )}
          
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));